import _ from "underscore";
import templateUrl from 'emun.salesrep/salesrep-sales-monthly.htm'

class SalesRepSalesMonthController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
		$ctrl.months = [
			{
				id: 1,
				name: 'Jan',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 2,
				name: 'Feb',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 3,
				name: 'Mar',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 4,
				name: 'Apr',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 5,
				name: 'May',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 6,
				name: 'Jun',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 7,
				name: 'Jul',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 8,
				name: 'Aug',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 9,
				name: 'Sep',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 10,
				name: 'Oct',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 11,
				name: 'Nov',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
			{
				id: 12,
				name: 'Dec',
				thisYear: 0,
				lastYear: 0,
				percent: 0,
				trend: ""
			},
		];
		$ctrl.monthSales = _.indexBy($ctrl.months, 'id');
        var filter = "SalesRepID";
        if ($ctrl.context == 'manager') { filter = "ManagerId";}
		if ($ctrl.context == 'executive') { filter = ''; }
		if ($ctrl.context == 'vendor') {
			filter = "VendorId";
		}
        var today = new Date();
		$ctrl.results = [];
        var thisYearUrl = 'QuerySalesDailyTotals.json?Sum=SalesDailyTotal&GroupBy=Month&dateRange=YTD';
        if ($ctrl.repGroup) {
            if ($ctrl.repGroup != 'ALL') {
                thisYearUrl = thisYearUrl + '&RepGroupName=' + $ctrl.repGroup;
            }
        }
        if (filter != '') {
            thisYearUrl = thisYearUrl + '&' + filter + '=' + $ctrl.rep.id;
        }
        $ctrl.monthlySalesTY = createAutoQuery({
            url: thisYearUrl,
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function(tyResults) {
				tyResults.results.forEach(function(res) 
				{
					$ctrl.monthSales[res.month].thisYear = res.sumSalesDailyTotal || 0;
				});
				var lastYearUrl = thisYearUrl.replace("dateRange=YTD", "dateRange=LastYear");
				$ctrl.monthlySalesLY = createAutoQuery({
					url: lastYearUrl,
					autoLoad: true,
					pageSize: 1000,
					onLoaded: function(lyResults) {
						lyResults.results.forEach(function(res) {
							$ctrl.monthSales[res.month].lastYear = res.sumSalesDailyTotal || 0;
							$ctrl.monthSales[res.month].diff = $ctrl.monthSales[res.month].thisYear - $ctrl.monthSales[res.month].lastYear; 
							var percent = Math.round(($ctrl.monthSales[res.month].thisYear / $ctrl.monthSales[res.month].lastYear) * 100);
							if ($ctrl.monthSales[res.month].lastYear == 0) { percent = 100;}
							if (percent < 100) {
								$ctrl.monthSales[res.month].percent = 100 - percent;
								$ctrl.monthSales[res.month].trend = 'down';
							} else if (percent > 100) {
								$ctrl.monthSales[res.month].percent = percent - 100;
								$ctrl.monthSales[res.month].trend = 'up';
							} else {
								$ctrl.monthSales[res.month].percent = 100;
								$ctrl.monthSales[res.month].trend = 'neutral';
							}
						});
					}
				});
            }
        });
    }
}

let SalesRepSalesMonth = {
    bindings: {
        rep: '<',
        repGroup: '@',
        context: '@'
    },
    controller: SalesRepSalesMonthController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default SalesRepSalesMonth